import { lazy } from 'react';
import type { RouteType } from 'src/hooks/useRouteElements';
import NewLayout from '../../layouts/NewFeatures/MainLayout';
import { PermissionEn } from '@martech-solution/utils/constants';
import accessControlPath from 'src/constants/urlPath/erp/accessControlPath';

const accessControl = lazy(() => import('src/pages/ERP/AccessControl'));

const AcceptancePermission = lazy(
  () => import('src/pages/ERP/AccessControl/AcceptancePermission/AcceptancePermission')
);
const AcceptancePermissionForm = lazy(
  () => import('src/pages/ERP/AccessControl/AcceptancePermission/Form/AddAcceptancePermission')
);
// Kho
const WarehousePermission = lazy(() => import('src/pages/ERP/AccessControl/WarehousePermission'));

const accessControlRoutes: RouteType[] = [
  {
    path: accessControlPath.accessControl,
    Layout: NewLayout,

    Component: accessControl
  },
  // AcceptancePermission - Quyền nghiệm thu
  {
    path: accessControlPath.acceptancePermission,
    Layout: NewLayout,
    Component: AcceptancePermission,
    checkPath: accessControlPath.acceptancePermission,
    permission: PermissionEn.read
  },
  {
    path: `${accessControlPath.acceptancePermissionDetail}/:id`,
    Layout: NewLayout,
    Component: AcceptancePermissionForm,
    checkPath: accessControlPath.acceptancePermission,
    permission: PermissionEn.viewDetail
  },
  {
    path: accessControlPath.acceptancePermissionAdd,
    Layout: NewLayout,
    Component: AcceptancePermissionForm,
    checkPath: accessControlPath.acceptancePermission,
    permission: PermissionEn.create
  },
  {
    path: `${accessControlPath.acceptancePermissionEdit}/:id`,
    Layout: NewLayout,
    Component: AcceptancePermissionForm,
    checkPath: accessControlPath.acceptancePermission,
    permission: PermissionEn.update
  },

  // Warehouse Permission - Quyền kho
  {
    path: accessControlPath.warehousePermission,
    Layout: NewLayout,
    Component: WarehousePermission,
    checkPath: accessControlPath.warehousePermission,
    permission: PermissionEn.read
  }
];

export default accessControlRoutes;
